export enum LocalizationType {
  KZ = 'kz',
  RU = 'ru',
  EN = 'en',
}
